webpackJsonp([242619241202873],{

/***/ 1546:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ReminderSilenceInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"datetime","type":{"kind":"SCALAR","name":"DateTime","ofType":null}},{"defaultValue":null,"description":null,"name":"note","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"patientId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"until","type":{"kind":"SCALAR","name":"DateTime","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-reminder-silence-input-fa6639d4eb9baf600503.js